import KineticClass, * as KineticModule from './../node_modules/ol/Kinetic.js';

// Create a wrapper class
class Kinetic extends KineticClass{
    constructor(options) {
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in KineticModule) {
    if (key !== "default") {
        Kinetic[key] = KineticModule[key];
    }
}

export default Kinetic;

// Re-export ALL named exports from OL
export * from './../node_modules/ol/Kinetic.js';